export const trackHotDrops = ({
  label,
}: {
  label: 'all' | 'upcoming' | 'active' | 'past' | 'last';
}) => {
  const event = {
    event: 'hotdrop',
    action: 'subscription',
    label: label,
    value: null,
  };

  return event;
};
